import { render, staticRenderFns } from "./certSign.vue?vue&type=template&id=42af08f2"
import script from "./certSign.vue?vue&type=script&lang=js"
export * from "./certSign.vue?vue&type=script&lang=js"
import style0 from "./certSign.vue?vue&type=style&index=0&id=42af08f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports